import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Pager, Selection, Scrolling
} from 'devextreme-react/data-grid';
import { Popup } from 'devextreme-react/popup';
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import NumberBox from 'devextreme-react/number-box';
import { SelectBox } from 'devextreme-react/select-box';
import CustomStore from "devextreme/data/custom_store";
import * as Utils from "../../utils/Utils";
import TreeView from 'devextreme-react/tree-view';
import DropDownBox from 'devextreme-react/drop-down-box';
import { showToast, parseDate, showDialog, hasRole, parseApiDate } from "../../utils/Utils";
import { ToastType } from "../../constants/Constants";
import './RaporUcretIslemleri.scss';
import Box, {
    Item
} from 'devextreme-react/box';
import TagBox from 'devextreme-react/tag-box';
import DateBox from 'devextreme-react/date-box';

const RaporUcretIslemleri = () => {

    const dispatch = useDispatch();

    const listeBasligi = "Rapor Ücret İşlemleri";

    const raporTipiListesi = [
        'İş kazası / Meslek hastalığı – Ayakta',
        'İş kazası / Meslek hastalığı – Yatarak',
        'Hastalık – Ayakta',
        'Hastalık – Yatarak',
        'Analık'
    ];

    const [store, setStore] = useState(null);
    const [tcKimlikNo, setTcKimlikNo] = useState(null);
    const [aramaSonucu, setAramaSonucu] = useState(null);
    const [son90GunToplamUcret, setSon90GunToplamUcret] = useState(null);
    const [son90GunToplamGun, setSon90GunToplamGun] = useState(null);
    const [gunlukUcret, setGunlukUcret] = useState(null);
    const [raporTipi, setRaporTipi] = useState(null);
    const [raporGunu, setRaporGunu] = useState(0);
    const [raporUcreti, setRaporUcreti] = useState(null);
    const [raporBaslangicTarihi, setRaporBaslangicTarihi] = useState(null);
    const [raporBitisTarihi, setRaporBitisTarihi] = useState(null);

    // Tarihler arasındaki gün sayısını hesaplama fonksiyonu
    const hesaplaRaporGunu = (baslangicTarihi, bitisTarihi) => {
        if (!baslangicTarihi || !bitisTarihi) {
            return 0;
        }

        const baslangic = new Date(baslangicTarihi);
        const bitis = new Date(bitisTarihi);

        // Tarihleri sadece tarih kısmına göre karşılaştırmak için saat bilgisini sıfırla
        baslangic.setHours(0, 0, 0, 0);
        bitis.setHours(0, 0, 0, 0);

        // Bitiş tarihi başlangıç tarihinden önceyse 0 döndür
        if (bitis < baslangic) {
            return 0;
        }

        // Gün farkını hesapla (ms cinsinden)
        const farkMs = bitis - baslangic;
        // Milisaniyeyi güne çevir (1 gün = 24 * 60 * 60 * 1000 ms)
        const farkGun = Math.floor(farkMs / (1000 * 60 * 60 * 24)) + 1; // +1 çünkü başlangıç günü de dahil

        return farkGun;
    };

    // Rapor ücreti hesaplama fonksiyonu
    const hesaplaRaporUcreti = (tip, gun, gunlukUcret) => {
        if (!tip || !gun || !gunlukUcret || gun <= 0) {
            return 0;
        }

        let hesaplananUcret = 0;

        switch (tip) {
            case 'İş kazası / Meslek hastalığı – Ayakta':
                // Günlük ücretin 2/3'si
                hesaplananUcret = gunlukUcret * 0.6667 * gun;
                break;
            case 'İş kazası / Meslek hastalığı – Yatarak':
                // Günlük ücretin %50'si
                hesaplananUcret = gunlukUcret * 0.50 * gun;
                break;
            
            case 'Hastalık – Ayakta':
                // 2 gün ödeme yapılmaz, 2 günden sonra %66,67'si
                if (gun > 2) {
                    hesaplananUcret = (gun - 2) * gunlukUcret * 0.6667;
                }
                break;
            
            case 'Hastalık – Yatarak':
                // 2 gün ödeme yapılmaz, 2 günden sonra %50
                if (gun > 2) {
                    hesaplananUcret = (gun - 2) * gunlukUcret * 0.50;
                }
                break;
            case 'Analık':
                // 2 gün ödeme yapılmaz, 2 günden sonra %50'si
                if (gun > 2) {
                    hesaplananUcret = (gun - 2) * gunlukUcret * 0.6667;
                }
                break;
            
            default:
                hesaplananUcret = 0;
        }

        return hesaplananUcret;
    };


    let dataGrid = null;

    const getStore = () => {
        let tempGrid = dataGrid;
        let currentTcKimlik = tcKimlikNo;

        return new CustomStore({
            key: 'donem',
            useDefaultSearch: false,
            load: function (loadOptions) {
                console.log("loadOptions", loadOptions);
                if (loadOptions.searchOperation == undefined) {
                    return;
                }

                // TC Kimlik numarası yoksa boş döndür
                if (!currentTcKimlik) {
                    return {
                        data: [],
                        totalCount: 0,
                        summary: 0,
                        groupCount: 0
                    };
                }

                const request = new Request(`/tesvikIslem/getRaporUcretHesapList/${currentTcKimlik}`, "GET");

                return request.run()
                    .then(response => {
                        if (response.data && response.data.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.data.length,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return {
                                data: [],
                                totalCount: 0,
                                summary: 0,
                                groupCount: 0
                            };
                        }
                    });
            }
        });
    }



 

    const tcKimlikAra = () => {
        if (!tcKimlikNo || tcKimlikNo.toString().length !== 11) {
            showToast('TC Kimlik numarası 11 haneli olmalıdır', ToastType.ERROR, 3000);
            return;
        }

        const request = new Request(`/tesvikIslem/getRaporUcretHesapList/${tcKimlikNo}`, "GET");
        
        return request.run()
            .then(response => {
                if (response.data && response.data.data) {
                    setAramaSonucu(response.data.data);
                    
                    // Sonuçları hesapla
                    const data = response.data.data;
                    
                    // Son 90 gündeki toplam ücret ve gün hesaplama
                    // Bir önceki ayı baz alarak, o aydan geriye doğru 3 ay (her ay 30 gün = 90 gün)
                    const bugun = new Date();
                    let birOncekiAyYil = bugun.getFullYear();
                    let birOncekiAyAy = bugun.getMonth() - 1; // Bir önceki ay (0-11 arası)
                    
                    // Ay negatif olursa yılı azalt
                    if (birOncekiAyAy < 0) {
                        birOncekiAyAy += 12;
                        birOncekiAyYil -= 1;
                    }
                    
                    // Verilerdeki tüm dönemleri parse et
                    const mevcutDonemler = [];
                    data.forEach(item => {
                        const donemStr = item.donem.toString();
                        const donemParts = donemStr.split('/');
                        if (donemParts.length === 2) {
                            const donemYil = parseInt(donemParts[0]);
                            const donemAy = parseInt(donemParts[1]) - 1; // JavaScript'te ay 0-11 arası
                            mevcutDonemler.push({
                                yil: donemYil,
                                ay: donemAy,
                                tarihNum: donemYil * 12 + donemAy,
                                data: item
                            });
                        }
                    });
                    
                    // Dönemleri tarihe göre sırala (en yeniden eskiye)
                    mevcutDonemler.sort((a, b) => b.tarihNum - a.tarihNum);
                    
                    // Bir önceki ayın tarih numarası
                    const birOncekiAyTarihNum = birOncekiAyYil * 12 + birOncekiAyAy;
                    
                    // Bir önceki ay verilerde var mı kontrol et
                    const birOncekiAyVar = mevcutDonemler.some(d => d.tarihNum === birOncekiAyTarihNum);
                    
                    let bitisTarihNum, baslangicTarihNum;
                    
                    if (birOncekiAyVar) {
                        // Bir önceki ay varsa: bir önceki aydan geriye doğru 3 ay
                        bitisTarihNum = birOncekiAyTarihNum;
                        baslangicTarihNum = birOncekiAyTarihNum - 2;
                    } else {
                        // Bir önceki ay yoksa: bir önceki aydan 1 ay geriye git, oradan 3 ay al
                        // Yani: bir önceki ay - 1 aydan başla, 3 ay geriye git
                        bitisTarihNum = birOncekiAyTarihNum - 1;
                        baslangicTarihNum = bitisTarihNum - 2;
                    }
                    
                    let toplamUcret = 0;
                    let toplamGun = 0;
                    
                    // Belirlenen aralıktaki verileri topla
                    mevcutDonemler.forEach(donem => {
                        if (donem.tarihNum >= baslangicTarihNum && donem.tarihNum <= bitisTarihNum) {
                            toplamUcret += (donem.data.toplam || 0);
                            toplamGun += (donem.data.gun || 0);
                        }
                    });
                    
                    setSon90GunToplamUcret(toplamUcret);
                    setSon90GunToplamGun(toplamGun);
                    
                    // Günlük ücret hesaplama
                    const gunlukUcretHesapla = toplamGun > 0 ? toplamUcret / toplamGun : 0;
                    setGunlukUcret(gunlukUcretHesapla);
                    
                    // Son kayıttan rapor bilgileri
                    if (data.length > 0) {
                        const sonKayit = data[data.length - 1];
                        setRaporTipi(sonKayit.raporTipi || '-');
                        // Tarih bilgileri varsa kullan, yoksa sıfırla
                        if (sonKayit.raporBaslangicTarihi) {
                            setRaporBaslangicTarihi(parseApiDate(sonKayit.raporBaslangicTarihi));
                        } else {
                            setRaporBaslangicTarihi(null);
                        }
                        if (sonKayit.raporBitisTarihi) {
                            setRaporBitisTarihi(parseApiDate(sonKayit.raporBitisTarihi));
                        } else {
                            setRaporBitisTarihi(null);
                        }
                        // Rapor gününü tarihlerden hesapla, yoksa eski değeri kullan
                        if (sonKayit.raporBaslangicTarihi && sonKayit.raporBitisTarihi) {
                            const hesaplananGun = hesaplaRaporGunu(
                                parseApiDate(sonKayit.raporBaslangicTarihi),
                                parseApiDate(sonKayit.raporBitisTarihi)
                            );
                            setRaporGunu(hesaplananGun);
                        } else {
                            setRaporGunu(sonKayit.gun || 0);
                        }
                        setRaporUcreti(sonKayit.ucret || 0);
                    } else {
                        setRaporTipi('-');
                        setRaporBaslangicTarihi(null);
                        setRaporBitisTarihi(null);
                        setRaporGunu(0);
                        setRaporUcreti(0);
                    }
                    
                    // Grid'i güncelle
                    setStore(getStore());
                } else {
                    setAramaSonucu([]);
                    setSon90GunToplamUcret(0);
                    setSon90GunToplamGun(0);
                    setGunlukUcret(0);
                    setRaporTipi('-');
                    setRaporBaslangicTarihi(null);
                    setRaporBitisTarihi(null);
                    setRaporGunu(0);
                    setRaporUcreti(0);
                    showToast('Sonuç bulunamadı', ToastType.INFO, 3000);
                }
            })
            .catch(error => {
                showToast('Arama sırasında bir hata oluştu', ToastType.ERROR, 3000);
                console.error('Arama hatası:', error);
            });
    }

    const onTcKimlikChanged = (e) => {
        setTcKimlikNo(e.value);
    }





    return (
        <React.Fragment>

            <h2 className={'dx-icon-product'}>{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px", marginBottom: "10px" }}>
                    <Box direction="row" width={850} height={35}> 
                        <Item ratio={0} baseSize={405}>
                            <div className="dx-field" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <div className="dx-field-label" style={{ width: '120px', marginRight: '5px' }}>TC Kimlik No</div>
                                <div className="dx-field-value" style={{ width: '150px', flex: '0 0 auto' }}>
                                    <TextBox 
                                        readOnly={false} 
                                        hoverStateEnabled={false} 
                                        value={tcKimlikNo}
                                        onValueChanged={onTcKimlikChanged}
                                        placeholder="11 haneli TC Kimlik No"
                                        maxLength={11}
                                    />
                                </div>
                            </div>
                        </Item>
                        <Item ratio={0} baseSize={10}></Item>
                        <Item ratio={0} baseSize={120}>
                            <Button 
                                icon="search" 
                                width={120} 
                                text="Ara" 
                                type={'default'} 
                                style={{ fontSize: "15px" }}
                                onClick={tcKimlikAra}
                            />
                        </Item>
                    </Box> 
                </div>
            </div>

            {aramaSonucu && aramaSonucu.length > 0 && (
                <div className="dx-field" style={{ marginLeft: "10px", marginBottom: "10px", padding: "10px", backgroundColor: "#f5f5f5", borderRadius: "4px" }}>
                    {/* 1. Satır: 3 sütun */}
                    <Box direction="row" width="1080px">
                        <Item ratio={0} baseSize={350}>
                            <div className="dx-field" style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="dx-field-label" style={{ width: '180px', flexShrink: 0 }}>Son 90 Gündeki Toplam Ücret</div>
                                <div className="dx-field-value" style={{ flex: '1', minWidth: '150px' }}>
                                    <NumberBox 
                                        readOnly={false} 
                                        value={son90GunToplamUcret || 0}
                                        onValueChanged={(e) => {
                                            const yeniUcret = e.value || 0;
                                            setSon90GunToplamUcret(yeniUcret);
                                            // Günlük ücreti hesapla
                                            if (son90GunToplamGun && son90GunToplamGun > 0) {
                                                setGunlukUcret(yeniUcret / son90GunToplamGun);
                                            } else {
                                                setGunlukUcret(0);
                                            }
                                        }}
                                        format="#,##0.00"
                                        showSpinButtons={false}
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </Item>
                        <Item ratio={0} baseSize={10}></Item>
                        <Item ratio={0} baseSize={350}>
                            <div className="dx-field" style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="dx-field-label" style={{ width: '180px', flexShrink: 0 }}>Son 90 Gündeki Toplam Gün</div>
                                <div className="dx-field-value" style={{ flex: '1', minWidth: '150px' }}>
                                    <NumberBox 
                                        readOnly={false} 
                                        value={son90GunToplamGun || 0}
                                        onValueChanged={(e) => {
                                            const yeniGun = e.value || 0;
                                            setSon90GunToplamGun(yeniGun);
                                            // Günlük ücreti hesapla
                                            if (yeniGun > 0 && son90GunToplamUcret) {
                                                setGunlukUcret(son90GunToplamUcret / yeniGun);
                                            } else {
                                                setGunlukUcret(0);
                                            }
                                        }}
                                        format="#,##0"
                                        showSpinButtons={false}
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </Item>
                        <Item ratio={0} baseSize={10}></Item>
                        <Item ratio={0} baseSize={350}>
                            <div className="dx-field" style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="dx-field-label" style={{ width: '180px', flexShrink: 0 }}>Günlük Ücret</div>
                                <div className="dx-field-value" style={{ flex: '1', minWidth: '150px' }}>
                                    <NumberBox 
                                        readOnly={false} 
                                        value={gunlukUcret || 0}
                                        onValueChanged={(e) => {
                                            const yeniGunlukUcret = e.value || 0;
                                            setGunlukUcret(yeniGunlukUcret);
                                            // Rapor ücretini hesapla
                                            const hesaplananUcret = hesaplaRaporUcreti(raporTipi, raporGunu, yeniGunlukUcret);
                                            setRaporUcreti(hesaplananUcret);
                                        }}
                                        format="#,##0.00"
                                        showSpinButtons={false}
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </Item>
                    </Box>
                    {/* 2. Satır: 3 sütun */}
                    <Box direction="row" width="1080px" style={{ marginTop: "10px" }}>
                        <Item ratio={0} baseSize={350}>
                            <div className="dx-field" style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="dx-field-label" style={{ width: '180px', flexShrink: 0 }}>Rapor Tipi</div>
                                <div className="dx-field-value" style={{ flex: '1', minWidth: '150px' }}>
                                    <SelectBox 
                                        dataSource={raporTipiListesi}
                                        value={raporTipi}
                                        onValueChanged={(e) => {
                                            const yeniTip = e.value;
                                            setRaporTipi(yeniTip);
                                            // Rapor ücretini hesapla
                                            const hesaplananUcret = hesaplaRaporUcreti(yeniTip, raporGunu, gunlukUcret);
                                            setRaporUcreti(hesaplananUcret);
                                        }}
                                        placeholder="Seçiniz..."
                                        searchEnabled={true}
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </Item>
                        <Item ratio={0} baseSize={10}></Item>
                        <Item ratio={0} baseSize={350}>
                            <div className="dx-field" style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="dx-field-label" style={{ width: '180px', flexShrink: 0 }}>Rapor Başlangıç Tarihi</div>
                                <div className="dx-field-value" style={{ flex: '1', minWidth: '150px' }}>
                                    <DateBox 
                                        value={raporBaslangicTarihi}
                                        onValueChanged={(e) => {
                                            const yeniBaslangic = e.value;
                                            setRaporBaslangicTarihi(yeniBaslangic);
                                            // Rapor gününü hesapla
                                            const hesaplananGun = hesaplaRaporGunu(yeniBaslangic, raporBitisTarihi);
                                            setRaporGunu(hesaplananGun);
                                            // Rapor ücretini hesapla
                                            const hesaplananUcret = hesaplaRaporUcreti(raporTipi, hesaplananGun, gunlukUcret);
                                            setRaporUcreti(hesaplananUcret);
                                        }}
                                        type="date"
                                        displayFormat="dd.MM.yyyy"
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </Item>
                        <Item ratio={0} baseSize={10}></Item>
                        <Item ratio={0} baseSize={350}>
                            <div className="dx-field" style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="dx-field-label" style={{ width: '180px', flexShrink: 0 }}>Rapor Bitiş Tarihi</div>
                                <div className="dx-field-value" style={{ flex: '1', minWidth: '150px' }}>
                                    <DateBox 
                                        value={raporBitisTarihi}
                                        onValueChanged={(e) => {
                                            const yeniBitis = e.value;
                                            setRaporBitisTarihi(yeniBitis);
                                            // Rapor gününü hesapla
                                            const hesaplananGun = hesaplaRaporGunu(raporBaslangicTarihi, yeniBitis);
                                            setRaporGunu(hesaplananGun);
                                            // Rapor ücretini hesapla
                                            const hesaplananUcret = hesaplaRaporUcreti(raporTipi, hesaplananGun, gunlukUcret);
                                            setRaporUcreti(hesaplananUcret);
                                        }}
                                        type="date"
                                        displayFormat="dd.MM.yyyy"
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </Item>
                    </Box>
                    {/* 3. Satır: 2 sütun */}
                    <Box direction="row" width="1080px" style={{ marginTop: "10px" }}>
                        <Item ratio={0} baseSize={350}>
                            <div className="dx-field" style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="dx-field-label" style={{ width: '180px', flexShrink: 0 }}>Rapor Günü</div>
                                <div className="dx-field-value" style={{ flex: '1', minWidth: '150px' }}>
                                    <NumberBox 
                                        readOnly={true} 
                                        value={raporGunu !== null && raporGunu !== undefined ? raporGunu : 0}
                                        format="#,##0"
                                        showSpinButtons={false}
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </Item>
                        <Item ratio={0} baseSize={10}></Item>
                        <Item ratio={0} baseSize={350}>
                            <div className="dx-field" style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="dx-field-label" style={{ width: '180px', flexShrink: 0 }}>Rapor Ücreti</div>
                                <div className="dx-field-value" style={{ flex: '1', minWidth: '150px' }}>
                                    <NumberBox 
                                        readOnly={true} 
                                        value={raporUcreti || 0}
                                        format="#,##0.00"
                                        showSpinButtons={false}
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </Item>
                    </Box>
                </div>
            )}

            <DataGrid
                className="sgkIslemleriGrid"
                ref={ref => dataGrid = ref}
                style={{ padding: 5 }}
                width="100%"
                //height="100%"
                dataSource={store}
                key="donem"
                keyExpr="donem"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                repaintChangesOnly={true}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                //selection={{mode: 'multiple', deferred:true}}
                remoteOperations={false}
            >
                <FilterRow visible={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Paging defaultPageSize={12} />


                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} allowEditing={false} />
                <Column dataField={'personelTckNo'} width={100} caption={'Tc'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField={'personelAdi'} width={100} caption={'Adı'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField={'personelSoyadi'} width={100} caption={'Soyadı'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField={'domain'} width={100} caption={'Tc'} dataType="Firma" visible={true} allowEditing={false} />
                <Column dataField="donem" width={80} caption={'Dönem'} dataType="Dönem" visible={true} allowEditing={false} />
                <Column dataField="ucret" width={80} caption={'Ücret'} dataType="number" format={{ type: "fixedPoint", precision: 2 }} visible={true} allowEditing={false} />
                <Column dataField="ikramiye" width={80} caption={'ikramiye'} dataType="number" format={{ type: "fixedPoint", precision: 2 }} visible={true} allowEditing={false} />
                <Column dataField="toplam" width={80} caption={'toplam'} dataType="number" format={{ type: "fixedPoint", precision: 2 }} visible={true} allowEditing={false} />
                <Column dataField="gun" width={80} caption={'gun'} dataType="number" format={{ type: "fixedPoint", precision: 0 }} visible={true} allowEditing={false} />
                <Column dataField="ggun" width={80} caption={'ggun'} dataType="number" format={{ type: "fixedPoint", precision: 0 }} visible={true} allowEditing={false} />
                <Column dataField="cgun" width={80} caption={'cgun'} dataType="number" format={{ type: "fixedPoint", precision: 0 }} visible={true} allowEditing={false} />


            </DataGrid>


        </React.Fragment>
    );
}

export default RaporUcretIslemleri;
